module.exports = __webpack_public_path__ + "img/copper.be5030ca.webp";